import * as ss from 'superstruct';
import { AdSources } from './paid-source.resource';

/**
 * Google Ads tracking types that identify clicks.
 * - gclid: Exact tracking - unique per click
 * - gbraid/wbraid: Apple device tracking (privacy-preserving)
 */
export const GoogleAdsTrackingType = ss.enums(['gclid', 'gbraid', 'wbraid']);
export type GoogleAdsTrackingType = ss.Infer<typeof GoogleAdsTrackingType>;

/**
 * Google Ads non-identifying query parameters injected by Google.
 */
export const GoogleAdsNonIdentifyingQueryParams = ss.enums([
  'gad_source',
  'gad_campaignid',
]);
export type GoogleAdsNonIdentifyingQueryParams = ss.Infer<
  typeof GoogleAdsNonIdentifyingQueryParams
>;

/**
 * All tracking query parameter keys that can be extracted from URLs.
 */
export const TrackingQueryParamKey = ss.union([
  ss.enums(['fbclid']),
  GoogleAdsTrackingType,
  ss.enums(['msclkid']),
  ss.enums(['oppref']),
  GoogleAdsNonIdentifyingQueryParams,
]);
export type TrackingQueryParamKey = ss.Infer<typeof TrackingQueryParamKey>;

/**
 * Maps each ad source to its available tracking query parameter keys.
 */
export const TrackingQueryParamKeysBySource: Record<
  AdSources,
  TrackingQueryParamKey[]
> = {
  meta: ['fbclid'],
  google: ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'],
  linkedin: [],
  bing: ['msclkid'],
  reddit: [],
  // OpenAI appends `oppref` to every ad landing URL.
  openai: ['oppref'],
  // Email click params are vendor-specific per ESP (mc_eid, _kx, ...), so
  // they're registered per-org as CustomTrackingParams instead.
  email: [],
};
